<div
  class="severity-label"
  [ngClass]="{
    small: smallSize,
    wide: wideSize,
    greyOut:
      supportedSeverity === supportedSeverityLabels.coming_soon ||
      supportedSeverity === supportedSeverityLabels.insufficient_data ||
      supportedSeverity === supportedSeverityLabels.pendingAssessment,
    healthy: supportedSeverity === supportedSeverityLabels.healthy,
    informational: supportedSeverity === supportedSeverityLabels.informational,
    low: supportedSeverity === supportedSeverityLabels.low,
    medium: supportedSeverity === supportedSeverityLabels.medium,
    high: supportedSeverity === supportedSeverityLabels.high,
    critical: supportedSeverity === supportedSeverityLabels.critical,
  }"
>
  <div class="severity-content">
    <app-severity-bars [severity]="supportedSeverity"></app-severity-bars>
    <span class="severity-text">{{ supportedSeverity | beautifyDisplayString }}</span>
  </div>
</div>
